import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Box } from 'grid-styled';
import media from 'utils/media';

import Container from 'components/Container';
import Footer from 'components/Footer';
import Features from 'components/Features';
import SignUpSection from 'components/SignUpSectionSecondary';
import Hero from './components/Hero';
import About from './components/About';
import Video from './components/Video';
import Gallery from './components/Gallery';

import * as images from './images';

const featureItems = [
  'recoveryseed',
  'instructions',
  'treatment',
  'download',
];

const Line = styled.div`
  ${media.sm.css`
    border-bottom: 1px solid #ccc;
  `};
`;

class Skywallet extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setRef = this.setRef.bind(this);
    this.handleScrollToSection = this.handleScrollToSection.bind(this);
  }

  setRef(ref) {
    this.newsletter = ref;
  }

  handleScrollToSection() {
    window.location = 'https://store.skycoin.com/products/skywallet';
  }

  render() {
    const { intl } = this.props;
    return (
      <div>
        <Helmet>
          <title>{intl.formatMessage({ id: 'sky_wallet.title' })}</title>
          <meta
            name="description"
            content={intl.formatMessage({ id: 'sky_wallet.description' })}
          />
        </Helmet>
        <Hero onClick={this.handleScrollToSection} />
        <About />
        <Box>
          <Features items={featureItems} images={images} textId="sky_wallet.features" />
          <Container>
            <Line />
          </Container>
        </Box>
        <Video />
        <Gallery />
        <SignUpSection />
        <Footer />
      </div>
    );
  }
}

Skywallet.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default injectIntl(Skywallet);



// WEBPACK FOOTER //
// ./src/components/Skywallet/Skywallet.js